import React from 'react';
import { CTAButton } from './CTAButton';
const questions = ['What should I assess?', 'What should I record?', 'What should I analyze?', 'What should I validate?', 'When should I reassess?'];
export function About() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-19" data-mp="2trr3ccyfuxph">
      <div className="mx-auto max-w-3xl" data-id="element-20" data-mp="2yt8488gxak62">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-21" data-mp="2ypsl8uk4oqzd">
          Meet Dr. Karito
        </h2>
        <p className="mt-1 text-center font-display text-sm font-600 uppercase tracking-[0.2em] text-gold-400" data-id="element-22" data-mp="38pb57b01gcrf">
          Creator of DVO Master Protocol™
        </p>

        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10 bg-navy-900" data-id="element-23" data-mp="3hienbwlmpdse">
          <img src="https://cdn.magicpatterns.com/uploads/2Z9YdGm9wKRKeDaY8biDMZ/Dra._Karito_Odontologa_OF.png" alt="Dr. Karito in her dental clinic" className="block w-full object-cover sm:max-h-[520px] sm:object-top" width={944} height={1520} loading="lazy" data-id="element-24" data-mp="3mhzmo84pno5n" />

          <div className="p-5 sm:p-7" data-id="element-25" data-mp="2grcnbqrbcuc3">
            <p className="text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-26" data-mp="2gugyx973yscs">
              DVO Master Protocol™ was created around a simple clinical need: turning complex
              knowledge into practical tools that dentists can actually use when they have a case in
              front of them.
            </p>

            <p className="mt-5 text-[11px] font-700 uppercase tracking-[0.2em] text-slate-400" data-id="element-27" data-mp="30flhu7gbxcer">
              Dr. Karito’s mission is simple:
            </p>
            <p className="mt-2 font-display text-xl font-700 uppercase leading-tight text-gold-400 sm:text-2xl" data-id="element-28" data-mp="2vnahx4ll9qm7">
              Make DVO assessment more structured, practical, and repeatable.
            </p>

            <p className="mt-5 text-sm leading-relaxed text-slate-300" data-id="element-29" data-mp="3o7shbfhcpzie">
              This isn’t about adding another textbook to your library. It’s about having a system
              you can open when you have a case in front of you and need to organize:
            </p>

            <ul className="mt-4 space-y-2" data-id="element-30" data-mp="b4f2uv5bxobr">
              {questions.map(question => <li key={question} className="rounded-lg border-l-2 border-gold-500 bg-navy-950 px-4 py-2.5 text-sm font-500 text-white" data-id="element-31" data-mp="3ti4rru17rgn8">
                  {question}
                </li>)}
            </ul>

            <p className="mt-5 text-sm leading-relaxed text-slate-300" data-id="element-32" data-mp="3ok38b7zvlfb8">
              DVO Master Protocol™ brings those elements together into one practical clinical
              system.
            </p>
          </div>
        </div>

        <p className="mt-8 text-center font-display text-xl font-700 uppercase leading-tight text-white sm:text-2xl" data-id="element-33" data-mp="3em5joje3tgi3">
          Apply the same structured process to your own case planning
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-34" data-mp="1ctqxh84j1pvv">
          <CTAButton label="Get instant access now" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-35" data-mp="2xc1m3g8sk84y" />
        </div>
      </div>
    </section>;
}